<template>
  <ProposalInfos
    :proposal="proposal"
    :initial-tab="initialTab"
    v-if="!loading"
    @update="reload"
  ></ProposalInfos>
</template>
<script>
import { fetchHil } from "../utils";
import ProposalInfos from "../components/proposal/ProposalInfos";
export default {
  components: { ProposalInfos },
  props: { initialTab: { type: Boolean } },
  data() {
    return {
      loading: true,
      proposal: null
    };
  },

  methods: {
    async reload() {
      const { lease_id, host_id } = this.$route.params;
      this.proposal = await (await fetchHil(
        `/proposals/lease/${lease_id}/host/${host_id}`
      )).json();
    }
  },

  async mounted() {
    this.loading = true;
    await this.reload();
    this.loading = false;
  },

  computed: {
    host() {
      return this.proposal.host._id;
    }
  }
};
</script>
<style></style>
